export const getInputTime = (value: string) => {
  const regex = /^(?:(\p{L}+)\s)?(\d{2}:\d{2})$/u
  const match = value.match(regex)
  if (!match) return { weekday: null, time: null }
  const weekday = match[1] || null
  const time = match[2]

  return { weekday, time }
}
